
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySnowShowersNightColour as ObiHeavySnowShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-snow-showers-night-colour.js';
 
 
 

 
 export const ObiHeavySnowShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-heavy-snow-showers-night-colour',
   elementClass: ObiHeavySnowShowersNightColourElement,
   events: {
     
   }
  });
 
 